var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}],staticClass:"top-panel"},[_c('div',{staticClass:"top-panel__logo"}),_c('div',{staticClass:"top-panel__buttons-block"})])}
var staticRenderFns = []

export { render, staticRenderFns }